import { Pagination } from "antd";
import styled, { SimpleInterpolation } from "styled-components";

export const StyledPagination = styled(Pagination)<{
  customCSS?: SimpleInterpolation;
}>`
  &.renderbus-ui--pagination {
    .ant-pagination-item-link {
      background: transparent;
      border: 0;
      color: rgba(255, 255, 255, 0.26);
    }
    .ant-pagination-item {
      background: #333336;
      border-radius: 3px;
      color: rgba(255, 255, 255, 0.85);
      border: 0;
      &:hover {
        background: #333336 !important;
        color: rgba(255, 255, 255, 0.85) !important;
      }
      &.ant-pagination-item-active {
        background: var(--main-color) !important;
        border: 0;
      }
      a {
        color: rgba(255, 255, 255, 0.85) !important;
      }
    }
    .ant-pagination-item-link svg {
      color: rgba(255, 255, 255, 0.26);
      &:hover {
        color: var(--main-color);
      }
    }
    .ant-pagination-next:hover .ant-pagination-item-link {
      color: var(--main-color);
    }
    .ant-pagination-item-link-icon {
      color: var(--main-color) !important;
    }
    .ant-pagination-item-ellipsis {
      color: rgba(255, 255, 255, 0.85) !important;
    }
    .ant-pagination-disabled:hover .ant-pagination-item-link svg {
      color: #000 !important;
    }
    .ant-pagination-options
      .ant-select:not(.ant-select-customize-input)
      .ant-select-selector,
    .ant-select-arrow {
      background: #333336;
      border-radius: 3px;
      border: 0;
      color: rgba(255, 255, 255, 0.85);
    }
    .ant-pagination-options-quick-jumper input {
      background: #333336;
      border-radius: 3px;
      border: 0;
    }
  }
  &.renderbus-ui--pagination__in-table {
    display: flex;
    justify-content: flex-end;
  }

  &.renderbus-ui--pagination__in-table.renderbus-ui--pagination__in-table__gap {
    margin-top: 16px;
  }
  ${(p) => p.customCSS};
`;
